import {
    Coordinates,
    MapData,
    MapDirectionsSetting,
    MapIsochroneSetting,
    MapOptions,
    MapSearchOptions,
    MapTheme,
    PolygonThemeSetting,
} from '@bpd-library/types';

import { MapLayerRasterSettings } from '../../store';
import addData from './add-data';
import center from './center';
import { addDirections, removeDirections } from './directions/directions';
import { addIsochrone, removeIsochrone } from './isochrone';
import setupPointers from './pointers/setup-pointers';
import setFeatureState from './polygons/feature-state';
import geojson from './polygons/geojson';
import interaction from './polygons/interaction';
import layer from './polygons/layer';
import raster from './raster';
import search from './search/search';

const mapbox = (map: mapboxgl.Map, options: MapOptions, theme: MapTheme) => ({
    raster: (settings: MapLayerRasterSettings) => raster(map, settings),
    geojson: (setting: PolygonThemeSetting) => geojson(map, setting),
    layer: (setting: PolygonThemeSetting) => layer(map, setting),
    interaction: (setting: PolygonThemeSetting) => interaction(map, setting),
    center: (coordinates: Coordinates) => center(map, coordinates),
    setupPointers: (element: HTMLElement) => setupPointers(map, theme, element),
    addData: (data: MapData) => addData(map, data, theme, options),
    setFeatureState: (variant: string, id: string, type: 'hover' | 'focus', hover: boolean) =>
        setFeatureState(map, variant, id, type, hover),
    search: (searchOptions: MapSearchOptions) => search(map, searchOptions, options),
    addIsochrone: (isochroneSetting: MapIsochroneSetting) => addIsochrone(map, isochroneSetting),
    removeIsochrone: () => removeIsochrone(map),
    addDirections: (directionsSetting: MapDirectionsSetting) =>
        addDirections(map, directionsSetting),
    removeDirections: () => removeDirections(map),
});

export default mapbox;
